module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAASdJREFUOE+l0zlLX0EUhvGfW0A0hIBboY1GbQS1csHCr66NouACojEWFlqYKASiQTBB5Q0zcLn8RYwDw+XOOe9zlpnT5Z2rq4P+AyYwhP5iv8c1LvCnqWkDRjGDq7J/F+dBjCH2U/yokCYgxi84QBW2EwxoHmcVUgFJewl7RdyLvy11PQtkEdsppwKm0F3IcVzBEX4WyGfMYauAU2Z6cV4BiX6M25YgkKyIm8BPmMVOBaxjE4+NtGvUHDXF+e/BGjb+F5AyVxO0WcIJfr2hhPRhtwImEeq38n2tian/odnEPixjH3cF8tI1fsRC+xqT+QimcVggnaYk4jykr7iJQ/spB5L0vpedbOIzUJ5y7OnVP3EnQM5SzjiGyzA9IcMU0eVrw/Tm4X4GDH9LEYMA/+sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 22